export interface Tile {
  id: string;
  label: { hr: string; en: string };
}

export interface Template {
  id: string;
  title: { hr: string; en: string };
  tiles: Tile[];
}

function tile(id: string, hr: string, en: string): Tile {
  return { id, label: { hr, en } };
}

export function templateFor(program?: string | null): Template {
  switch (program) {
    case 'minbarlive_growth':
      return {
        id: 'funnel',
        title: { hr: 'Lijevak', en: 'Funnel' },
        tiles: [
          tile('researched', 'Istraženo', 'Researched'),
          tile('qualified', 'Kvalificirano', 'Qualified'),
          tile('recommended', 'Preporuke za kontakt', 'Contact recommendations'),
          tile('conversations', 'Razgovori', 'Conversations'),
        ],
      };
    case 'zoho_hotel_solutions':
      return {
        id: 'hotel',
        title: { hr: 'Hotel', en: 'Hotel' },
        tiles: [
          tile('revenue', 'Prihod', 'Revenue'),
          tile('occupancy', 'Popunjenost', 'Occupancy'),
          tile('adr', 'ADR', 'ADR'),
          tile('revpar', 'RevPAR', 'RevPAR'),
          tile('yoy_week', 'Tjedan naspram prošle godine', 'Week vs last year'),
          tile('competitor_prices', 'Cijene konkurencije', 'Competitor prices'),
          tile('city_events', 'Događaji u gradu', 'City events'),
        ],
      };
    case 'megabooker_sales_growth':
      return {
        id: 'sales',
        title: { hr: 'Prodaja', en: 'Sales' },
        tiles: [
          tile('leads', 'Leadovi', 'Leads'),
          tile('qualified', 'Kvalificirano', 'Qualified'),
          tile('meetings', 'Sastanci', 'Meetings'),
          tile('won', 'Zatvoreno', 'Won'),
        ],
      };
    default:
      return {
        id: 'generic',
        title: { hr: 'Pregled', en: 'Overview' },
        tiles: [],
      };
  }
}
